// extracted by mini-css-extract-plugin
module.exports = {"tiles_carousel":"TileCarousel_tiles_carousel__1PQxZ"};